import React, {useEffect} from "react";
import "../style/elements/resultant-damage-cover-popup.scss";

interface Props {
    onOk: () => void;
}

export default function ResultantDamageCover({ onOk }: Props) {
    // Prevent background scrolling when popup is open
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <div className="popup-body">
                    <p>
                        You have chosen to not select Resultant Damage from both Escape of
                        Liquid and Major Faults and Defects Cover.
                        <br />
                        <br />
                        This means that both Section 1, Exclusion C - Escape of Liquid and
                        General Exclusion Major Faults and Defects apply to your insurance
                        policy. Please ensure you have read and understood these policy
                        exclusions prior to proceeding with your request for cover.
                        <br />
                        <br />
                        By proceeding with cover you acknowledge Your Policy will not include
                        cover for Escape of Liquid from items including but not limited to
                        white goods, drains, fixed pipes, bathroom fixtures, and redundant
                        flexi-hoses, as well as no cover for Major Faults and Defects which
                        include but are not limited to waterproofing failures, fire system
                        failures, balconies and balustrading, non-compliant cladding and EPS.
                    </p>
                    <div className="popup-actions">
                        <button className="popup-ok-button" onClick={onOk}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}